import React from 'react';

import {HeaderTabNavigation, MainHeader, PageWrapperLayout} from 'presentation/components';
import {myAppointmentsTabs} from './constants';
import {useMyAppointments} from './hooks/useMyAppointments';
import {StyledStack} from './styles';

export function MyAppointments() {
	const {pageTitle, handleBack, hideTabs, isMobile} = useMyAppointments();

	return (
		<PageWrapperLayout title={pageTitle()}>
			<MainHeader title={pageTitle()} handleBack={handleBack} />
			{hideTabs ? null : (
				<StyledStack>
					<HeaderTabNavigation
						tabs={myAppointmentsTabs}
						variant={isMobile ? 'fullWidth' : 'scrollable'}
						customTabProps={{sx: {padding: '8px 16px'}}}
					/>
				</StyledStack>
			)}
		</PageWrapperLayout>
	);
}
